import React from 'react';
import { Helmet } from 'react-helmet-async';

const StructuredData = ({ type = "organization" }) => {
  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "Traain",
    "legalName": "Traain",
    "url": "https://traain.com",
    "logo": "https://customer-assets.emergentagent.com/job_talent-iq-deploy/artifacts/6uqpwydk_Train%20Logo.png",
    "description": "Traain is an enterprise training and enablement platform powered by Navigator AI™. Move teams forward with intelligent training, role-play, and performance enablement.",
    "foundingDate": "2024",
    "contactPoint": {
      "@type": "ContactPoint",
      "contactType": "Customer Service",
      "email": "support@traain.com",
      "url": "https://traain.com/contact"
    },
    "sameAs": [
      process.env.REACT_APP_LINKEDIN_URL || "https://www.linkedin.com/company/traain",
      process.env.REACT_APP_FACEBOOK_URL || "https://www.facebook.com/traain"
    ]
  };

  const productSchema = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    "name": "Traain Platform",
    "applicationCategory": "BusinessApplication",
    "operatingSystem": "Web",
    "offers": {
      "@type": "AggregateOffer",
      "priceCurrency": "USD",
      "lowPrice": "15",
      "highPrice": "20",
      "priceSpecification": {
        "@type": "UnitPriceSpecification",
        "price": "15",
        "priceCurrency": "USD",
        "billingDuration": "P1M",
        "unitText": "per user"
      }
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.8",
      "ratingCount": "150"
    },
    "description": "Enterprise training and enablement platform powered by Navigator AI™ for intelligent training, role-play, and performance"
  };

  const schema = type === "organization" ? organizationSchema : productSchema;

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(schema)}
      </script>
    </Helmet>
  );
};

export default StructuredData;
